export function dateFormatterWithConditionalYear(
  date: Date | null | string | undefined,
): string {
  if (!date) return "";

  const dateObj = new Date(date);
  const today = new Date();

  // Use UTC methods to avoid timezone issues
  const year = dateObj.getUTCFullYear();
  const month = dateObj.getUTCMonth();
  const day = dateObj.getUTCDate();

  const localDate = new Date(Date.UTC(year, month, day));

  const oneYearAgo = new Date(
    Date.UTC(today.getFullYear() - 1, today.getMonth(), today.getDate()),
  );
  const shouldShowYear = localDate <= oneYearAgo;

  const formatter = Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
    ...(shouldShowYear && { year: "numeric" }),
  });

  return formatter.format(localDate);
}
